import { useCallback, useState } from 'react';
import styled, { css } from 'foundations-theming/utils';
import DraggableTile, { DRAGGABLE_ITEM_TYPES } from 'InpageEditorUI/components/sidebar/add/DraggableTile';
import { Button } from 'foundations-components/transitional/components/Button';
import { AddIcon } from 'foundations-assets';
import FormattedMessage from 'I18n/components/FormattedMessage';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'Cont... Remove this comment to see the full error message
import { setSelectedUpgradableModule } from 'ContentEditorUI/redux/actions/appActions';
import { useDispatch } from 'react-redux';
import { MODULES_BY_PATH_MARKED_AS_NEW } from 'ContentEditorUI/redux/constants';
import { PATAGONIA_ADD_PANEL_SUB_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const TRUNCATED_TILE_NUM = 8;
const listItemStyle = css(["list-style:none;position:relative;"]);
const tileListBase = css(["margin:", ";padding:", ";padding-block-end:", ";"], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['0'], ({
  theme
}) => theme.space['300']);
const TileListGrid = styled.ul.withConfig({
  displayName: "addWidgetHelpers__TileListGrid",
  componentId: "xnrn5l-0"
})([".hs-private.hs-private.hs-private &{", " display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:", ";}.hs-private.hs-private.hs-private & > li{", "}"], tileListBase, ({
  theme
}) => theme.space['300'], listItemStyle);
const TileListStacked = styled.ul.withConfig({
  displayName: "addWidgetHelpers__TileListStacked",
  componentId: "xnrn5l-1"
})([".hs-private.hs-private.hs-private &{", " display:flex;flex-direction:column;gap:", ";}.hs-private.hs-private.hs-private & > li{", "}"], tileListBase, ({
  theme
}) => theme.space['300'], listItemStyle);
const PQLTile = ({
  pqlId,
  moduleSchema,
  type,
  sidebarIframeBody
}) => {
  const dispatch = useDispatch();
  return /*#__PURE__*/_jsx(DraggableTile, {
    isDraggable: false,
    draggableItemType: DRAGGABLE_ITEM_TYPES.TILE,
    schema: moduleSchema,
    type: type,
    sidebarIframeBody: sidebarIframeBody,
    hideTooltips: false,
    useLockedRibbon: true,
    onMouseDown: () => {
      dispatch(setSelectedUpgradableModule(pqlId));
    }
  });
};
const useTiles = ({
  collection,
  type,
  upgradableModules = []
}) => {
  const isAllModules = type === 'allModules' || type === PATAGONIA_ADD_PANEL_SUB_CATEGORIES.MODULES.ALL;
  const draggableItemType = isAllModules ? DRAGGABLE_ITEM_TYPES.OBJECT : DRAGGABLE_ITEM_TYPES.TILE;
  function getInitialModuleState(modules, endIndex) {
    const shouldTruncate = !isAllModules;
    return shouldTruncate ? modules.slice(0, endIndex) : modules;
  }
  const [visibleCollection, setVisibleCollection] = useState(getInitialModuleState(collection, TRUNCATED_TILE_NUM));
  const [visibleUpgradableModules, setVisibleUpgradableModules] = useState(getInitialModuleState(upgradableModules, TRUNCATED_TILE_NUM - visibleCollection.length));
  const handleAddMoreClick = useCallback(() => {
    setVisibleCollection(collection);
    setVisibleUpgradableModules(upgradableModules);
  }, [collection, upgradableModules]);
  const totalTiles = collection.length + upgradableModules.length;
  const totalVisibleTiles = visibleCollection.length + visibleUpgradableModules.length;
  const shouldRenderShowMore = totalTiles > totalVisibleTiles;
  return {
    draggableItemType,
    handleAddMoreClick,
    shouldRenderShowMore,
    visibleCollection,
    visibleUpgradableModules
  };
};
export const TileList = ({
  hideTooltips,
  collection,
  onDragStart,
  onDragEnd,
  type,
  sidebarIframeBody,
  upgradableModules = []
}) => {
  const {
    draggableItemType,
    handleAddMoreClick,
    shouldRenderShowMore,
    visibleCollection,
    visibleUpgradableModules
  } = useTiles({
    collection,
    type,
    upgradableModules
  });
  const StyledListElement = draggableItemType === DRAGGABLE_ITEM_TYPES.OBJECT ? TileListStacked : TileListGrid;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsxs(StyledListElement, {
      "data-test-id": "common-widgets-list",
      children: [visibleCollection.map((schema, i) => {
        const useNewRibbon = MODULES_BY_PATH_MARKED_AS_NEW.includes(schema.path);
        return /*#__PURE__*/_jsx(DraggableTile, {
          draggableItemType: draggableItemType,
          hideTooltips: hideTooltips,
          sidebarIframeBody: sidebarIframeBody,
          onDragEnd: onDragEnd,
          onDragStart: onDragStart,
          type: type,
          schema: schema,
          useNewRibbon: useNewRibbon
        }, i);
      }), visibleUpgradableModules.map((schema, i) => /*#__PURE__*/_jsx(PQLTile, {
        pqlId: schema.pqlId,
        moduleSchema: schema.moduleSchema,
        type: type,
        sidebarIframeBody: sidebarIframeBody
      }, i + collection.length))]
    }), shouldRenderShowMore && /*#__PURE__*/_jsxs(Button, {
      onClick: handleAddMoreClick,
      use: "transparent",
      children: [/*#__PURE__*/_jsx(AddIcon, {}), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "addModule.showMore"
      })]
    })]
  });
};
export const renderLazyTileList = ({
  hideTooltips,
  collection,
  onDragStart,
  onDragEnd,
  type,
  sidebarIframeBody,
  shouldRenderTourStep,
  upgradableModules
}) => () => /*#__PURE__*/_jsx(TileList, {
  hideTooltips: hideTooltips,
  collection: collection,
  onDragStart: onDragStart,
  onDragEnd: onDragEnd,
  type: type,
  sidebarIframeBody: sidebarIframeBody,
  shouldRenderTourStep: shouldRenderTourStep,
  upgradableModules: upgradableModules
});